import api from './api';

// ========== PERMISSIONS ==========

// جلب جميع الصلاحيات
export const getPermissions = async () => {
  const response = await api.get('/roles/permissions');
  return response.data;
};

// إنشاء صلاحية جديدة
export const createPermission = async (data) => {
  const response = await api.post('/roles/permissions', data);
  return response.data;
};

// تحديث صلاحية
export const updatePermission = async (id, data) => {
  const response = await api.put(`/roles/permissions/${id}`, data);
  return response.data;
};

// حذف صلاحية
export const deletePermission = async (id) => {
  const response = await api.delete(`/roles/permissions/${id}`);
  return response.data;
};

// ========== ROLES ==========

// جلب جميع الأدوار
export const getRoles = async () => {
  const response = await api.get('/roles');
  return response.data;
};

// جلب دور معين
export const getRoleById = async (id) => {
  const response = await api.get(`/roles/${id}`);
  return response.data;
};

// إنشاء دور جديد
export const createRole = async (data) => {
  const response = await api.post('/roles', data);
  return response.data;
};

// تحديث دور
export const updateRole = async (id, data) => {
  const response = await api.put(`/roles/${id}`, data);
  return response.data;
};

// حذف دور
export const deleteRole = async (id) => {
  const response = await api.delete(`/roles/${id}`);
  return response.data;
};

// جلب المستخدمين الذين لديهم دور معين
export const getRoleUsers = async (id) => {
  const response = await api.get(`/roles/${id}/users`);
  return response.data;
};

// تعيين دور لمستخدم
export const assignRole = async (roleId, userId) => {
  const response = await api.post(`/roles/${roleId}/assign/${userId}`);
  return response.data;
};
